//长度
export const checkLength = (rule, value, callback) => {
  console.log(rule)
  if (value) {
    if (value.length > 40) {
      callback(new Error('长度最多为40'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//手机号码
export const checkMobile = (rule, value, callback) => {
  if (value) {
    var reg = /^1\d{10}$/
    if (reg.test(value) === false) {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//邮箱
export const checkEmail = (rule, value, callback) => {
  if (value) {
    var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
    if (reg.test(value) === false) {
      callback(new Error('请输入正确的邮箱'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//微信号 微信官方限制微信号为28字符，数字和字母
export const checkWechat = (rule, value, callback) => {
  if (value) {
    var reg = /^[A-Za-z0-9]{6,28}$/
    if (reg.test(value) === false) {
      callback(new Error('请输入正确的微信号'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//金额 (不可输负数)
export const checkMoney = (rule, value, callback) => {
  if (value) {
    var reg = /^[0-9]{1,7}(\.[0-9]{1,2})?$/
    if (reg.test(value) === false) {
      callback(new Error('请输入有效的金额'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//金额 (可输负数)
export const checkMoneyNegative = (rule, value, callback) => {
	if (value) {
	  var reg = /^([-+])?\d+(\.[0-9]{1,2})?$/
	  if (reg.test(value) === false) {
		callback(new Error('请输入有效的金额'))
	  } else {
		callback()
	  }
	} else {
	  callback()
	}
  }
export const checkWeight = (rule, value, callback) => {
  if (value) {
    var reg = /^[0-9]{1,7}(\.[0-9]{1,2})?$/
    if (reg.test(value) === false) {
      callback(new Error('请输入有效的重量'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//7位正整数
export const checkNumber = (rule, value, callback) => {
  if (value) {
    var reg = /^[1-9]\d{0,6}$/
    if (reg.test(value) === false) {
      callback(new Error('请输入1-7位的整数'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//40位数字字母组合
export const checkId = (rule, value, callback) => {
  if (value) {
    var reg = /^[A-Za-z0-9]{0,40}$/
    if (reg.test(value) === false) {
      callback(new Error('请输入40位以内的数字或字母'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 编号、编码 七位数字和字母
export const checkCode = (rule, value, callback) => {
  if (value) {
    var reg = /^[A-Za-z0-9]{0,15}$/
    if (reg.test(value) === false) {
      callback(new Error('请输入15位以内的数字或字母'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//只允许输入1到10位汉字，不允许输入数字及特殊字符
export const allNames = (rule, value, callback) => {
  if (value) {
    var reg = /^([\u4e00-\u9fa50-9A-z]{1,10})$/gi
    if (reg.test(value) === false) {
      callback(new Error('最多输入10位'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//sn码，50位数字或字母组合
export const checkSn = (rule, value, callback) => {
  if (value) {
    var reg = /^[A-Za-z0-9]{0,50}$/
    if (reg.test(value) === false) {
      callback(new Error('只允许输入数字或字母'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//有效ip
export const checkIP = (rule, value, callback) => {
  if (value) {
    var reg = /^((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])(?::(?:[0-9]|[1-9][0-9]{1,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))?$/
    if (reg.test(value) === false) {
      callback(new Error('请输入有效的ip'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//ip地址格式校验
export const checkIp = (rule, value, callback) => {
  if (value) {
    var reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
    if (reg.test(value) === false) {
      callback(new Error('请输入正确的ip地址'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//有效sn码
export const checkSN = (rule, value, callback) => {
  if (value) {
    var reg = /^[A-Za-z0-9]{0,50}$/
    if (reg.test(value) === false) {
      callback(new Error('请输入有效的sn码'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//网关地址格式校验
export const checkWangguan = (rule, value, callback) => {
  if (value) {
    var reg = /^(192\.168(\.(\d|([1-9]\d)|(1\d{2})|(2[0-4]\d)|(25[0-5]))){2})$/
    if (reg.test(value) === false) {
      callback(new Error('请输入正确的网关地址'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//mac地址
export const checkMac = (rule, value, callback) => {
  if (value) {
    var reg = /^([0-9a-fA-F]{2})(([/\s:-][0-9a-fA-F]{2}){5})$/
    if (reg.test(value) === false) {
      callback(new Error('请输入有效的mac地址'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 域名
export const checkHost = (rule, value, callback) => {
	if(value && (!(/^https:\/\/[0-9A-z\-]{1,62}(\.[0-9A-z\-]{1,62})+$/.test(value)) || value.includes('--'))) {
		callback(new Error('格式错误，参考：https://xxx.com'))
		return
	}
	callback()
}
// 域名或ip不带端口
export const checkIpOrHost = (rule, value, callback) => {
	const host=/^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/
	const ipv4=/^((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])?$/
	if(value&&!((host).test(value)||(ipv4).test(value))){
		callback(new Error('示例:https://xxx.com或192.168.1.101'))
		return
	}
	console.log((host).test(value)||(ipv4).test(value),'host和ipv4');
	// console.log((ipv4).test(value),'ipv4');
	callback()
}
//端口号
export const checkPort = (rule, value, callback) => {
	if(value && (!(/^([0-9]|[1-9][0-9]{1,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])?$/.test(value)) || value.includes('--'))) {
		callback(new Error('范围:0~65535'))
		return
	}
	callback()
}
export const checkLngLat = (rule, value, callback) => {
	if(value && !(/^(-?(?:1?[0-7]\d|\d{1,2})(?:\.\d+)?|180(?:\.0+)?)$/.test(value))) {
		callback(new Error('格式不正确'))
		return
	}
	callback()
}